<template>
  <div class="downloads_container">
    <div class="downloads_content">
      <div class="downloads_tit">研究报告</div>
      <!-- <div class="downloads_tabs">
        <div
          :class="[
            'downloads_tab',
            item.category_id == cur_category_id ? 'act' : '',
          ]"
          v-for="(item, ind) in tabs_list"
          :key="ind"
          @click="changeTab(item.category_id)"
        >
          {{ item.name }}
        </div>
      </div> -->
      <div class="downloads_list">
        <el-table
          empty-text="暂无数据,敬请期待。"
          :data="tableData"
          style="width: 100%"
          :scrollbar-always-on="true"
        >
          <!-- <el-table-column prop="report_num" label="编号" /> -->
          <el-table-column prop="report_name" label="报告名称" class="report_name"/>
          <el-table-column prop="published" label="发布日期" width="250"/>
          <el-table-column label="操作" width="100">
            <template #default="scope">
              <template v-if="scope.row.has_permission == 1">
                <div class="down_btn" @click="downLoad(scope.row)">下载</div>
              </template>
              <template v-else>
                <div class="down_btn" @click="downLoad(null)">下载</div>
              </template>
            </template>
          </el-table-column>
        </el-table>
        <div class="list_pagination" v-show="totalPage>1">
          <el-pagination
            v-model:currentPage="currentPage"
            :background="true"
            layout="prev, pager, next, jumper"
            :page-count="totalPage"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import { ElTable, ElTableColumn, ElPagination, ElMessage} from "element-plus";
import { getDownloadsList,downReport} from "@/api";
import { getCookie } from '@/plugins/cookie'
export default {
  components: {
    ElTable,
    ElTableColumn,
    ElPagination,
  },
  setup() {
    const cur_category_id = ref(0);
    const tabs_list = [
      {
        name: "全部",
        category_id: 0,
      },
      {
        name: "月报",
        category_id: 1,
      },
      {
        name: "行业趋势",
        category_id: 2,
      },
      {
        name: "测评报告",
        category_id: 3,
      },
    ];
    const tableData = ref([]);
    const totalPage = ref(0);
    const currentPage = ref(1);
    const handleCurrentChange = (val) => {
      getDownloadsListFn({ page: val });
    };
    const getDownloadsListFn = (obj = {}) => {
      let { category_id, page } = obj;
      getDownloadsList({
        category_id: category_id || cur_category_id.value,
        page: page || currentPage.value,
        size: 10,
      }).then((res) => {
        if (res && res.code && res.code == 200) {
          tableData.value = res.data.list;
          totalPage.value = res.data.total_page;
        }
      });
    };
    const changeTab = (category_id) => {
      cur_category_id.value = category_id;
      getDownloadsListFn({ category_id, page: 1 });
    };
    getDownloadsListFn();

    const downLoad = (report)=>{
      const loginToken =  getCookie('loginToken');
      if(report && report.report_num){
        downReport({
          report_num:report.report_num
        },
        {
          responseType: 'arraybuffer',
          headers: {
            appvars: {"loginToken": loginToken},
            ContentType:'application/json'
          },
        }
        ).then(response => {
          if (response && response.code && response.code === 500) {
              ElMessage.error(response.message || "暂无下载权限!");
              return;
          }

          let arrayBuffer = response; // Assuming response is ArrayBuffer

          let blob = new Blob([arrayBuffer], { type: 'application/octet-stream' });

          let url = URL.createObjectURL(blob);

          let a = document.createElement('a');
          a.style.display = 'none';
          a.href = url;
          a.download = decodeURIComponent(report.file_name);
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        })
      }else{
        ElMessage.error("暂无下载权限!");
      }
    }
    return {
      cur_category_id,
      tabs_list,
      tableData,
      totalPage,
      currentPage,
      handleCurrentChange,
      changeTab,
      downLoad
    };
  },
};
</script>

<style lang="less" scoped>
:deep(.el-pagination.is-background .el-pager li:not(.disabled).active){
  background-color: #1FBCBF;
}
:deep(.el-pagination .btn-next .el-icon) {
  margin: 0 auto;
}
:deep(.el-pagination .btn-prev .el-icon){
  margin: 0 auto;
}
:deep(.el-table__row){
  height: 50px;
}
:deep(.el-table_1_column_1 .cell){
  color: #474747;
}

.downloads_content {
  width: 1100px;
  height: calc(100vh - 128px);
  padding: 39px 69px 35px 63px;
  background: #ffffff;
  border-radius: 13px;
  overflow-y: auto;
  .downloads_tit {
    height: 31px;
    font-size: 20px;
    font-weight: bold;
    color: #474747;
    line-height: 31px;
    position: relative;
    padding-left: 10px;
  }
  .downloads_tabs {
    margin-top: 30px;
    display: flex;
    align-items: center;
    height: 48px;
    .downloads_tab {
      cursor: pointer;
      margin-right: 25px;
      padding: 0 25px;
      height: 100%;
      font-size: 20px;
      font-weight: bold;
      color: #474747;
      line-height: 48px;
      text-align: center;
      &.act {
        border-bottom: solid 4px #1FBCBF;
        border-radius: 2px;
      }
    }
  }
  .downloads_list {
    margin-top: 21px;
    height: calc(100% - 52px);
    :deep(.el-table) {
      height: calc(100% - 50px);
      overflow-y: auto;
    }
    .list_pagination {
      display: flex;
      justify-content: center;
      
    }
  }
}
.down_btn{
  cursor: pointer;
  color: #1435eb;
}
:deep(.el-table::before){
  height: 0;
}
</style>